module.exports = __webpack_public_path__ + "static/media/humanislets-Figure7.6706cd1c.jpg";